import 'polyfills' // <- import polyfills before everything else

import React from 'react'
import { createRoot } from 'react-dom/client'

import { Provider } from 'react-redux'
import { createLogger } from 'redux-logger'
import { configureStore } from '@reduxjs/toolkit'
import reportWebVitals from 'reportWebVitals'

import App from 'App'
import Stores from 'redux/Stores'

import { registerResizeObserverErrorSuppression } from 'utils/suppressResizeObserverError'

import 'styles/colors.css'
import 'styles/index.css'

registerResizeObserverErrorSuppression()

const LoggerMiddleware = createLogger()

const app = (
  <Provider
    store={configureStore({
      reducer: Stores,
      middleware: (getDefaultMiddleware) => {
        // Match the previous plain thunk+logger setup: the legacy state tree
        // is not fully serializable, so keep RTK 2's dev checks off.
        const middleware = getDefaultMiddleware({
          immutableCheck: false,
          serializableCheck: false
        })

        return process.env.NODE_ENV !== 'production'
          ? middleware.concat(LoggerMiddleware)
          : middleware
      },
      devTools: process.env.NODE_ENV !== 'production'
    })}
  >
    <App />
  </Provider>
)

const root = createRoot(document.getElementById('root'))

if (window.location.pathname === '/signout') {
  window.close()
}

root.render(app)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
